import { axiosV2 } from 'interceptors/axios';

import { decryptResponse } from 'utils/token';

export const getAdministratedPartners = async (userId: string) => {
  const query = { params: { userId } };
  try {
    const { data } = await axiosV2.get(`/partners`, query);

    const decodedData = await decryptResponse(data);

    return decodedData;
  } catch (error) {
    throw new Error();
  }
};
